
export const CONTACT_INFO = {
  mainPhone: "9845974238",
//   mainWhatsapp: "9845974238",
  mainWhatsappLink: "https://wa.me/919845974238",
  email: "madeshwaraa@gmail.com",
  phone2: "9845645056",
  phone3: "9108258470",
  phone4: "9980294858",
  address: "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
};
